import axios from 'axios';
const headers = { 'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('userDetails'))?.token, 'Accept-Language': localStorage.getItem('currentLanguage')};

const providerStatusService = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_ADMIN_BACKEND,
  headers: headers
});
export const startHeartbeat = (providerId, authToken) => {
    const sendHeartbeat = () => {
      const data = {
        providerId,
        isOnline: true,
        ipAddress: '', // Pourrait être récupéré via une API
        userAgent: navigator.userAgent
      };
      providerStatusService.post('/ProviderStatus/update', data);
    };
    
    // Envoyer immédiatement un premier signal
    sendHeartbeat();
    
    // Configurer l'intervalle régulier (par exemple toutes les minutes)
    const intervalId = setInterval(sendHeartbeat, 60000);
    
    // Gestionnaire d'événements pour détecter quand l'utilisateur quitte la page
    const handleBeforeUnload = () => {
        providerStatusService.post('/ProviderStatus/update', JSON.stringify({
        providerId,
        isOnline: false
      }));
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    // Retourner une fonction pour nettoyer
    return () => {
      clearInterval(intervalId);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  };